import React, { Component } from 'react'
import Flight, { Rect, Oval } from 'react-flight/dom'
import PropTypes from 'prop-types'
import AppBar from './app-bar'

/*
-import { h } from 'preact'
-import React, { Children, Component } from 'preact-compat'
*/

class App extends Component {
  componentDidMount() {}
  render() {
    return (
      <Flight interactive>
        <Flight.Frame duration={300} source>
          <div>
            <AppBar />
            <div
              className="keyframe"
              style={{
                border: 'none',
                backgroundColor: '#F4F7F9',
                height: 280,
              }}
            >
              <Rect
                name="head-1"
                radius={5}
                style={{
                  backgroundColor: '#95A2AA',
                  left: 30,
                  top: 20,
                  width: 50,
                  height: 10,
                }}
              />

              <Rect
                name="head-2"
                radius={5}
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 120,
                  top: 20,
                  width: 120,
                  height: 10,
                }}
              />

              <Rect
                name="head-3"
                radius={5}
                style={{
                  backgroundColor: '#E6ECF0',
                  right: 50,
                  top: 20,
                  width: 30,
                  height: 10,
                }}
              />

              <Rect
                name="head-4"
                radius={5}
                style={{
                  backgroundColor: '#E6ECF0',
                  right: 15,
                  top: 20,
                  width: 30,
                  height: 10,
                }}
              />

              <Rect
                name="detail-1"
                radius={5}
                style={{
                  backgroundColor: '#FF6D4A',
                  left: 232,
                  top: 100,
                  width: 120,
                  height: 10,
                }}
              />

              <Rect
                name="detail-2"
                radius={5}
                style={{
                  backgroundColor: '#95A2AA',
                  right: 40,
                  top: 120,
                  width: 120,
                  height: 10,
                }}
              />

              <Rect
                name="detail-3"
                radius={5}
                style={{
                  backgroundColor: '#95A2AA',
                  right: 40,
                  top: 140,
                  width: 120,
                  height: 10,
                }}
              />

              <Rect
                name="button"
                radius={5}
                style={{
                  backgroundColor: '#E6ECF0',
                  right: 40,
                  top: 160,
                  width: 40,
                  height: 20,
                }}
              />

              <Rect
                name="img-bg"
                radius={5}
                style={{
                  backgroundColor: '#E6ECF0',
                  left: 80,
                  top: 120,
                  width: 90,
                  height: 90,
                }}
              />

              <Rect
                name="img-main"
                radius={5}
                style={{
                  backgroundColor: '#4DA1FF',
                  left: 50,
                  top: 100,
                  width: 90,
                  height: 90,
                }}
              />

              <div
                id="brace-1"
                className="brace-1"
                style={{ color: '#95A2AA', top: 30, left: -50, fontSize: 30 }}
              >
                {'{'}
              </div>
              <div
                id="brace-2"
                className="brace-2"
                style={{ color: '#95A2AA', top: 180, left: -50, fontSize: 30 }}
              >
                {'}'}
              </div>
            </div>
          </div>

        </Flight.Frame>

        <Flight.Frame duration={300}>
          <div className="keyframe">
            <Rect
              name="head-1"
              radius={5}
              style={{
                backgroundColor: '#95A2AA',
                left: -60,
                top: 20,
                width: 50,
                height: 10,
              }}
            />

            <Rect
              name="head-2"
              radius={5}
              style={{
                backgroundColor: '#E6ECF0',
                left: 120,
                top: -15,
                width: 120,
                height: 10,
              }}
            />

            <Rect
              name="head-3"
              radius={5}
              style={{
                backgroundColor: '#E6ECF0',
                right: -40,
                top: 20,
                width: 30,
                height: 10,
              }}
            />

            <Rect
              name="head-4"
              radius={5}
              style={{
                backgroundColor: '#E6ECF0',
                right: -80,
                top: 20,
                width: 30,
                height: 10,
              }}
            />

            <Rect
              name="detail-1"
              radius={5}
              style={{
                backgroundColor: '#FF6D4A',
                left: 50,
                top: 90,
                width: 120,
                height: 10,
              }}
            />

            <Rect
              name="detail-2"
              radius={5}
              style={{
                backgroundColor: '#95A2AA',
                right: -200,
                top: 120,
                width: 120,
                height: 10,
              }}
            />

            <Rect
              name="detail-3"
              radius={5}
              style={{
                backgroundColor: '#95A2AA',
                right: -220,
                top: 140,
                width: 120,
                height: 10,
              }}
            />

            <Rect
              name="button"
              radius={5}
              style={{
                backgroundColor: '#E6ECF0',
                right: -80,
                top: 200,
                width: 40,
                height: 20,
              }}
            />

            <Rect
              name="img-bg"
              radius={5}
              style={{
                backgroundColor: '#E6ECF0',
                left: 80,
                top: 360,
                width: 90,
                height: 90,
              }}
            />

            <Rect
              name="img-main"
              radius={5}
              style={{
                backgroundColor: '#4DA1FF',
                left: 50,
                top: 120,
                width: 60,
                height: 60,
              }}
            />

            <div
              id="brace-1"
              className="brace-1"
              style={{ color: '#95A2AA', top: 30, left: 20, fontSize: 30 }}
            >
              {'{'}
            </div>
            <div
              id="brace-2"
              className="brace-2"
              style={{ color: '#95A2AA', top: 190, left: 20, fontSize: 30 }}
            >
              {'}'}
            </div>
          </div>

        </Flight.Frame>

      </Flight>
    )
  }
}
App.contextTypes = { director: PropTypes.object }

export default App



// WEBPACK FOOTER //
// ./src/anim3.js